import { useMemo } from 'react'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Breadcrumb } from '@/ui'
import { useNavigate } from 'react-router-dom'

export const InsightBreadcrumb = ({
  month,
  year,
}: {
  month?: string | number | null
  year?: string | number | null
}) => {
  const navigate = useNavigate()

  const insightsLink = useMemo(() => {
    let baseLink = '/insights/overview?'
    if (month) {
      baseLink += `month=${month}&`
    }
    if (year) {
      baseLink += `year=${year}`
    }
    return baseLink
  }, [month, year])

  return (
    <Breadcrumb>
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link
            onClick={() => {
              navigate(insightsLink)
            }}
          >
            <Icon icon={faArrowLeft} />
            Back to Practice Insights
          </Breadcrumb.Link>
        </Breadcrumb.Item>
      </Breadcrumb.List>
    </Breadcrumb>
  )
}
